import React from 'react';
import Image from '@atoms/Image';

const WheelEdit = () => (
  <div className='w-56 h-28 absolute mt-14 z-50 right-2 bg-interactionIcons-playBtn rounded-lg shadow-interaction border border-gray-40'>
    <div className='w-48 mx-auto'>
      <div className='flex pt-4'>
        <Image src="/images/Paused.svg" alt='paused' />
        <span className='font-medium text-sm leading-3.5 text-white ml-3'>Moderating Options</span>
      </div>
      <div className='pt-4'>
        <span className='font-normal text-sm leading-4 text-neutral-50'>{'Close the moderation tab to restart the Choice Circle.'}</span>
      </div>
    </div>
  </div >
);

export default WheelEdit;
